import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc.js';
import timezone from 'dayjs/plugin/timezone.js';

dayjs.extend(utc);
dayjs.extend(timezone);

export default class DateManager {
  public static getToday() {
    return dayjs().tz("America/Sao_Paulo").toDate();
  }

  public static parseDateToISOString(date: string | Date): string {
    return dayjs(date).tz("America/Sao_Paulo").toISOString();
  }
}
